import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AuthService } from '@principle-theorem/ng-auth';
import { PageSplashComponent } from '@principle-theorem/ng-principle';

@Component({
  selector: 'pr-unauthorised',
  templateUrl: './unauthorised.component.html',
  styleUrls: ['./unauthorised.component.scss'],
  imports: [CommonModule, PageSplashComponent, MatButton, MatIcon],
})
export class UnauthorisedComponent {
  constructor(private _auth: AuthService) {}

  async logout(): Promise<void> {
    return this._auth.logout();
  }
}
